export const preferencesTypes = {
    toggleThemeMode: "[Preferences] toggleThemeMode",
};
